import React from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { Selectors } from '@americanexpress/axp-benefits-utils';
import { getProductRegistryById, getSelectedProduct } from '@americanexpress/product-ducks';
import DetailsPage from '../new/detail/components/DetailsPage';
import { ReadLoyaltyBenefitsVx } from '../constants';
import { getEndpoint, getReadBenefitsRequestBody } from '../api/api-utils';
import useOneData from '../hooks/useOneData';
import { extractHTMLInnerText } from '../utilities/extract-html-inner-text.js';

export function DetailsWrapper(properties) {
  const parameters = properties?.params || {};
  const cardNameState = properties?.cardNameState;
  const cardNameParams = parameters?.cardname;
  const getCardNameFromState = cardNameState?.data?.cardDetails?.cardName;
  const cardNameValueToUse = getCardNameFromState || cardNameParams;
  const locale = properties?.locale;
  const accountToken = properties?.accountToken;
  const login = properties?.login;
  const productType = properties?.productType;
  const requestBody = getReadBenefitsRequestBody(accountToken, cardNameValueToUse, login, productType, locale);
  const faasApiUrl = properties?.faasApiUrl;
  const endpoint = getEndpoint(faasApiUrl, ReadLoyaltyBenefitsVx);

  const endpointOptions = {
    body: requestBody,
  };

  const {
    data: readLoyaltyBenefits,
  } = useOneData(endpoint, endpointOptions);

  const benTitle = readLoyaltyBenefits?.benefits[parameters?.benname]?.benefitTitle;
  const cardNameFull = readLoyaltyBenefits?.cardProduct?.productLayout?.pageTitle.split('|')[0].trim();
  const cleanBenTitle = benTitle ? extractHTMLInnerText(benTitle.replace('TM', '&#8482;')) : {};

  return (
    <><DetailsPage
      {...properties}
      cardNameValueToUse={cardNameValueToUse}
    />
      <div>
        <Helmet
          title={`${cleanBenTitle} | ${cardNameFull} Benefits | American Express`}
          meta={[
            { name: 'description', content: `Learn More About ${cleanBenTitle} for Your ${cardNameFull} & Other American Express Card Benefits.` },
            { name: 'keywords', content: `${cardNameFull}, ${cardNameFull} Benefits, ${cleanBenTitle}` },
            { name: 'robots', content: '' },
          ]}
          link={[
            { rel: 'canonical', href: `${window.location.href}`.split('?')[0] },
          ]}
        />
      </div>
    </>

  );
}

export function mapStateToProps(state) {
  const product = getSelectedProduct(state);
  return {
    cardNameState: Selectors.getCardNameFromState(state),
    faasApiUrl: fromJS(state).getIn(['config', 'faasApiUrl']),
    env: fromJS(state).getIn(['config', 'localeFilename']),
    login: Boolean(getSelectedProduct(state)),
    productType: getProductRegistryById(state, product)?.type,
    accountToken: getSelectedProduct(state),
    locale: fromJS(state).getIn(['intl', 'activeLocale']),
  };
}

export const ComponentUnderTest = DetailsWrapper;
export default connect(mapStateToProps, null)(DetailsWrapper);
